import { Component } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
 imports:[CommonModule, FormsModule],
 standalone: true,
 selector:'app-verify-otp',
 templateUrl:'./verify-otp.component.html'
})
export class VerifyOtpComponent{

 otp:string=""
 error=""

 constructor(
  private auth:AuthService,
  private router:Router
 ){}

 verify(){

  this.auth.verifyLogin2FA(this.otp)
   .subscribe({

    next:(res:any)=>{

     localStorage.removeItem("tempToken")

     this.auth.saveToken(res.accessToken)

     this.router.navigate(['/app'])

    },

    error:()=>{
     this.error="Invalid verification code"
    }

   })

 }

}
